module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/80/assets/images/593cf2b65c443ab394c72b250cf6195f.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_unlock.svg
// module id = h4lv
// module chunks = 0